import React from 'react';

function Footer() {
    
    return (
        <footer className="page-footer">
            <div className="container">
                <div className="row">
                    <div className="col text-center py-4">
                        <h3>PicStore</h3>
                        <p>Copyright &copy; <span id="year"></span></p>
                        <button className="btn btn-primary">Contact Us</button>
                    </div>
                </div>
            </div>
        </footer>
    );
}

export default Footer;






